<div class="contextmenu" [ngStyle]="{ 'left.px': positionX, 'top.px': positionY }" data-cy="general-context">
  <!--  <div class="">-->
  <!--    <i class="material-icons close-button" (click)="emitCloseEvent()">close</i>  -->
<!--  </div>-->
<div data-cy="general-context-close-container">
  <div class="context-button close-button"
    (click)="emitCloseEvent()" data-cy="general-context-close-button">
    <i class="material-icons close-icon" data-cy="general-context-close-icon">close</i>
  </div>
</div>
@for (contextButton of actionButtons; track contextButton) {
  <div data-cy="general-context-action">
    <button mat-button color="primary"
      [disabled]="contextButton.disabled" class="context-button" (click)="emitClickEvent(contextButton)"
      [attr.data-cy]="'general-context-button-' + contextButton.displayText.toLowerCase().replace(' ', '-')">
      {{ contextButton.displayText }}
    </button>
  </div>
}
</div>
